import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Grid,
  Paper,
  Typography,
  TablePagination,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Toolbar,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Chip,
  Button,
  IconButton,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { Alert } from "@material-ui/lab";
import PrintIcon from "@material-ui/icons/Print";
import SearchIcon from "@material-ui/icons/Search";
import fileDownload from "js-file-download";
import GetAppIcon from "@material-ui/icons/GetApp";
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import { ImageRounded } from "@material-ui/icons";
import withServices from "../../hocs/withServices";
import Loader from "../utils/Loader";
import TablePaginationActions from "../utils/TablePaginationActions";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    flexDirection: "row",
  },
  title: {
    flex: "1 1 100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  formControl: {
    minWidth: "100%",
  },
  fioInput: {
    minWidth: "100%",
    height: "100%",
    "& .MuiInputBase-root": {
      height: "100%",
    },
  },
  buttonGroup: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    "& button": {
      marginRight: "10px",
    },
  },
}));

function Aet({ services }) {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [preview, setPreview] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [usersInfo, setUsersInfo] = useState();
  const rowsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(0);
  const [usersInfoCount, setUsersInfoCount] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = useState(true);
  const [openPreview, setOpenPreview] = useState(false);
  const [showError, setShowError] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewImageUserId, setPreviewImageUserId] = useState();
  const [selectedUserIds, setSelectedUserIds] = useState(new Set());
  const [imageUrls, setImageUrls] = useState({});

  const classes = useStyles();

  const resetFilter = () => {
    setStatus(false);
    setCurrentPage(0);
    setKeyword("");
    fetchData();
  };

  const fetchData = async () => {
    setLoading(true);
    await services.idCard
      .getUsersIdCardInfo({
        status: status,
        page: currentPage,
        keyword: keyword.replace(/\s/g, ""),
      })
      .then((response) => {
        setUsersInfo(() => {
          const { list, total_number } = response.data;
          setUsersInfoCount(total_number);
          setLoading(false);
          return list;
        });
      });
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [services, status, currentPage]);

  const loadImageUrl = (userId) => {
    services.idCard
      .getIdCardByUserId(userId, true)
      .then((response) => {
        setImageUrls((prevUrls) => ({
          ...prevUrls,
          [userId]: URL.createObjectURL(response.data),
        }));
      })
      .catch((error) => {
        console.error("Error loading image URL:", error);
      });
  };

  useEffect(() => {
    usersInfo?.forEach((userinfo) => {
      loadImageUrl(userinfo?.userId);
    });
  }, [usersInfo]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleSearchQueryChange = () => {
    fetchData();
  };

  const handleChangeStatus = (event) => {
    setStatus(event.target.value);
  };

  useEffect(() => {
    if (!open) {
      setErrorMessage("");
    }
  }, [open]);

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setShowError(false);
  }

  const handleClosePreview = () => {
    setOpenPreview(false);
  };

  const handleChangeUserIdList = (userId) => {
    if (selectedUserIds.has(userId)) {
      const updatedIds = new Set(selectedUserIds);
      updatedIds.delete(userId);
      setSelectedUserIds(updatedIds);
    } else {
      setSelectedUserIds(new Set(selectedUserIds).add(userId));
    }
  };

  const handleSelectAll = () => {
    if (selectedUserIds.size === usersInfo?.length) {
      setSelectedUserIds(new Set());
    } else {
      setSelectedUserIds(
        new Set(usersInfo?.map((userinfo) => userinfo?.userId))
      );
    }
  };

  const handleOpenPreview = (userId) => {
    services.idCard
      .getIdCardByUserId(userId, true)
      .then((response) => {
        setPreviewImage(URL.createObjectURL(response.data));
        setOpenPreview(true);
        setPreviewImageUserId(userId);
      })
      .catch((error) => {
        setErrorMessage("Ошибка с данными");
        setShowError(true);
        setOpen(true);
      })
      .finally(() => {
        setPreview(false);
      });
  };

  const handlePreviewImage = (userId) => {
    services.idCard
      .getIdCardByUserId(userId, true)
      .then((response) => {
        return URL.createObjectURL(response.data);
      })
      .catch((error) => {
        return null;
      });
  };

  const downloadInZip = () => {
    if (selectedUserIds.size === 0) {
      setErrorMessage("Ни один пользователь не выбран для загрузки.");
      setShowError(true);
      setOpen(true);
      return;
    }

    services.idCard
      .getIdCardsByUserIds(selectedUserIds)
      .then((response) => {
        const contentDisposition = response.headers["content-disposition"];
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        const filename =
          matches && matches[1] ? matches[1].replace(/['"]/g, "") : "image.png";
        fileDownload(response.data, filename);
        fetchData();
        setSelectedUserIds(new Set());
      })
      .catch((error) => {
        setErrorMessage("Ошибка с данными");
        setShowError(true);
        setOpen(true);
      });
  };

  const printIdCardByUserId = (userId) => {
    services.idCard
      .getIdCardByUserId(userId, false)
      .then((response) => {
        const contentDisposition = response.headers["content-disposition"];
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        const filename =
          matches && matches[1] ? matches[1].replace(/['"]/g, "") : "image.png";

        fileDownload(response.data, filename);
        fetchData();
      })
      .catch((error) => {
        setErrorMessage("Ошибка с данными");
        setShowError(true);
        setOpen(true);
      });
  };

  const downloadImage = (imageId, userId) => {
    services.fileUpload.getDocumentSecretary(
      userId, imageId, "Фото 3х4"
    )
      .catch((error) => {
        setErrorMessage("Ошибка с данными");
        setShowError(true);
        setOpen(true);
      });
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Paper className={classes.paper}>
          <Toolbar>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  className={classes.title}
                  variant="h6"
                  id="tableTitle"
                  component="div"
                >
                  Студенты
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item lg={6} xs={12}>
                    <TextField
                      placeholder="Введите ваш запрос (ФИО или ИИН, varcode)"
                      value={keyword}
                      onChange={(event) => setKeyword(event.target.value)}
                      className={classes.fioInput}
                    />
                  </Grid>
                  <Grid item lg={1} xs={12}>
                    <Button
                      onClick={handleSearchQueryChange}
                      variant="outlined"
                      color="primary"
                      startIcon={<SearchIcon />}
                    >
                      Поиск
                    </Button>
                  </Grid>
                  <Grid item lg={1} xs={12}>
                    <Typography
                      variant="h6"
                      style={{
                        paddingTop: "4px",
                        paddingLeft: "20px",
                      }}
                    >
                      Статус:
                    </Typography>
                  </Grid>
                  <Grid item lg={4} xs={12} alignItems="right">
                    <Grid container direction="row">
                      <FormControl component="fieldset">
                        <RadioGroup
                          aria-label="status"
                          name="status"
                          value={status}
                          onChange={handleChangeStatus}
                          row
                        >
                          <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Распечатанные"
                          />
                          <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="Непечатные"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid item lg={6} xs={6}>
                    <div className={classes.buttonGroup}>
                      <Button
                        variant="outlined"
                        onClick={resetFilter}
                        color="primary"
                        startIcon={<RotateLeftIcon />}
                        size="small"
                      >
                        Сбросить фильтр
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={downloadInZip}
                        color="primary"
                        startIcon={<GetAppIcon />}
                        size="small"
                      >
                        Скачать в архиве
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>

          <Table aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell>
                  <Checkbox
                    checked={selectedUserIds.size === usersInfo?.length}
                    onChange={handleSelectAll}
                  />
                </TableCell>
                <TableCell>Предпросмотр</TableCell>
                <TableCell>ФИО</TableCell>
                <TableCell>ИИН</TableCell>
                <TableCell>Имя на английском</TableCell>
                <TableCell>Фамилия на английском</TableCell>
                <TableCell>Varcode</TableCell>
                <TableCell>Статус</TableCell>
                <TableCell>Действие</TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody>
                {[...Array(10)].map((x, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton variant="text" />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            ) : (
              <TableBody>
                {usersInfo?.map((userinfo) => (
                  <TableRow key={userinfo?.id}>
                    <TableCell component="th" scope="row">
                      <Checkbox
                        checked={selectedUserIds.has(userinfo?.userId)}
                        onChange={() =>
                          handleChangeUserIdList(userinfo?.userId)
                        }
                      />
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: "50%" }}
                    >
                      {loading ? (
                        <Loader />
                      ) : (
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => handleOpenPreview(userinfo?.userId)}
                          size="small"
                          component="span"
                          style={{ width: "75%" }}
                        >
                          <img
                            src={imageUrls[userinfo?.userId]}
                            alt="ID Card Preview"
                            style={{ width: "100%" }}
                          />
                        </Button>
                      )}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {userinfo?.surname + " " + userinfo?.nameRu}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {userinfo?.iin}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {userinfo?.nameEn}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {userinfo?.surnameEn}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {userinfo?.varcode}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {userinfo?.status ? (
                        <Chip
                          label="напечатано"
                          color="primary"
                          variant="outlined"
                        />
                      ) : (
                        <Chip
                          label="не напечатано"
                          color="secondary"
                          variant="outlined"
                        />
                      )}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <IconButton
                        variant="outlined"
                        color="primary"
                        onClick={() => printIdCardByUserId(userinfo?.userId)}
                        size="small"
                        component="span"
                      >
                        <PrintIcon />
                      </IconButton>
                      <IconButton
                        variant="outlined"
                        color="primary"
                        onClick={() => downloadImage(userinfo?.image, userinfo?.userId)}
                        size="small"
                        component="span"
                      >
                        <ImageRounded />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
          <TablePagination
            count={usersInfoCount}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            component="div"
            rowsPerPageOptions={[]}
            onChangePage={handleChangePage}
            ActionsComponent={TablePaginationActions}
          />
          {showError && (
            <div>
              <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                ContentProps={{
                  "aria-describedby": "message-id",
                }}
              >
                <Alert
                  onClose={handleClose}
                  severity="warning"
                  variant="filled"
                  elevation={6}
                  sx={{ width: "100%" }}
                >
                  {errorMessage !== "" ? errorMessage : <>Не удалось!</>}
                </Alert>
              </Snackbar>
            </div>
          )}
          <div>
            <Dialog
              open={openPreview}
              onClose={handleClosePreview}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Предварительный просмотр ID CARD"}
              </DialogTitle>
              <DialogContent>
                {loading ? (
                  <Loader />
                ) : (
                  previewImage && (
                    <img
                      src={previewImage}
                      alt="ID Card Preview"
                      style={{ width: "100%" }}
                    />
                  )
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => printIdCardByUserId(previewImageUserId)}
                  color="primary"
                >
                  Скачать
                </Button>
                <Button onClick={handleClosePreview} color="primary" autoFocus>
                  Закрыть
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </Paper>
      )}
    </>
  );
}

export default withServices()(Aet);
